export default __webpack_public_path__ + "static/0305857a-9a8b-46ef-9487-5354e315c6b5-bbb1d1f8246bdae4ec90ebd29c4b17f8.woff";